/**
 * Shared "load more" handler. Configured via data-* attributes on the trigger
 * button (endpoint, offset, offset-increment, container); endpoints answer
 * `GET ?offset=N` with JSON { html, hasMore }.
 *
 * No CSRF token by design: these are GETs, so `isReading()` short-circuits the
 * middleware. A token would be useless anyway — the pages are served cookie-free,
 * so any rendered token is either Spatie's frozen placeholder or bound to a
 * session whose cookie was stripped.
 */

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.load-more-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var offset    = parseInt(btn.dataset.offset, 10) || 0;
            var increment = parseInt(btn.dataset.offsetIncrement, 10) || 8;
            var endpoint  = btn.dataset.endpoint;
            var container = document.querySelector(btn.dataset.container);

            if (!endpoint || !container) return;

            btn.disabled = true;

            var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'offset=' + offset;

            fetch(url, { headers: { Accept: 'application/json' } })
                .then(function (response) {
                    // Surface a failed request instead of dying inside json(): an error response is
                    // HTML, so json() throws a parse error that says nothing about the real cause —
                    // which is why the 419s went unnoticed.
                    if (!response.ok) {
                        throw new Error('load-more returned HTTP ' + response.status);
                    }
                    return response.json();
                })
                .then(function (data) {
                    if (data.html) {
                        container.insertAdjacentHTML('beforeend', data.html);
                        btn.dataset.offset = offset + increment;
                    }

                    if (!data.hasMore) {
                        btn.style.display = 'none';
                    } else {
                        btn.disabled = false;
                    }
                })
                .catch(function (error) {
                    console.error('load-more failed:', error);
                    btn.disabled = false;
                });
        });
    });
});
